import filterTableColumnsByRoles from '@/helpers/filterTableColumnsByRoles'

export default function () {
  const roles = this.currentUser ? this.currentUser.roles : null
  return filterTableColumnsByRoles(this.tableColumns, roles)
}
